module.exports = __webpack_public_path__ + "static/media/SeguroTuristaBlanco.baf0b0ee.png";